import { render, staticRenderFns } from "./OrderSessionsModal.vue?vue&type=template&id=2c1c3526&scoped=true"
import script from "./OrderSessionsModal.vue?vue&type=script&lang=js"
export * from "./OrderSessionsModal.vue?vue&type=script&lang=js"
import style0 from "./OrderSessionsModal.vue?vue&type=style&index=0&id=2c1c3526&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1c3526",
  null
  
)

export default component.exports